export enum AccountType {
  SPOT = 'SPOT',
  FUTURES = 'FUTURES',
}

const ACCOUNT_TYPES = Object.values(AccountType);

const ACCOUNT_TYPE_KEY = 'account_type';

const isAccountType = (value: string): value is AccountType => ACCOUNT_TYPES.includes(value as AccountType);

export const getAccountType = () => {
  const accountType = window.localStorage.getItem(ACCOUNT_TYPE_KEY);
  if (!accountType || !isAccountType(accountType)) return null;

  return accountType;
};

export const setAccountType = (accountType: AccountType) => {
  window.localStorage.setItem(ACCOUNT_TYPE_KEY, accountType);
};

export const unsetAccountType = () => {
  window.localStorage.removeItem(ACCOUNT_TYPE_KEY);
};
